import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllIdentifications = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetIdentifications}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getIdentificationById = async ({ companyCode,code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.IdentificationAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertIdentification = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.IdentificationAPI, input);
  return data;
};

const updateIdentification = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.IdentificationAPI, input);
  return data;
};

const deleteIdentification = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.IdentificationAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetIdentificationsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetIdentifications],
    queryFn: () => getAllIdentifications(input),
  });
};

export const useGetIdentificationByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.IdentificationAPI],
    queryFn: () => getIdentificationById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertIdentificationMutation = () => {
  return useMutation({
    mutationFn: insertIdentification,
  });
};

export const useUpdateIdentificationMutation = () => {
  return useMutation({
    mutationFn: updateIdentification,
  });
};

export const useDeleteIdentificationMutation = () => {
  return useMutation({
    mutationFn: deleteIdentification,
  });
};
